export default __webpack_public_path__ + "static/media/account.000bf640.png";